// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AssessmentPage_page__zUjt6 {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--gray-50);
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  padding-top: 48px;
}

/* Top Bar */
.AssessmentPage_topBar__BCkIR {
  height: 48px;
  background: white;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
}

.AssessmentPage_topBarLeft__mJcES { display: flex; align-items: center; gap: 0.65rem; }
.AssessmentPage_logoMark__gCyGC {
  width: 32px;
  height: auto;
  flex-shrink: 0;
}
.AssessmentPage_topBarTitle__iSfL0 { font-size: 0.78rem; font-weight: 500; color: var(--gray-700); }

/* Time Expired Banner */
.AssessmentPage_timeExpiredBanner__iXFh9 {
  background: var(--red);
  color: white;
  padding: 0.75rem 1rem;
  text-align: center;
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  z-index: 49;
}
.AssessmentPage_timeExpiredContent__E4TI2 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  max-width: 1200px;
  margin: 0 auto;
}
.AssessmentPage_timeExpiredIcon__MrT4K {
  font-size: 1.5rem;
}
.AssessmentPage_timeExpiredText__D2Y7C {
  font-size: 0.95rem;
}
.AssessmentPage_timeExpiredText__D2Y7C strong {
  font-size: 1.1rem;
}

.AssessmentPage_topBarCenter__fqs9I { display: flex; align-items: center; }
.AssessmentPage_timer__H-Qrl {
  display: flex; align-items: center; gap: 0.5rem;
  padding: 0.5rem 1.1rem;
  border: 2px solid var(--border);
  border-radius: 100px;
  background: white;
  transition: all 0.3s;
}
.AssessmentPage_timerWarn__uzDg2 { border-color: var(--red); background: var(--red-light); }
.AssessmentPage_timerIcon__VuRcv { font-size: 1rem; }
.AssessmentPage_timerVal__pOb5q { font-size: 1.1rem; font-weight: 700; color: var(--gray-900); font-variant-numeric: tabular-nums; letter-spacing: 0.02em; }
.AssessmentPage_timerWarn__uzDg2 .AssessmentPage_timerVal__pOb5q { color: var(--red); }
.AssessmentPage_timerExpired__wGsB\\+ { border-color: var(--red); background: var(--red); animation: AssessmentPage_pulse__vLf-B 1s infinite; }
.AssessmentPage_timerExpired__wGsB\\+ .AssessmentPage_timerVal__pOb5q { color: white; }
.AssessmentPage_timerExpired__wGsB\\+ .AssessmentPage_timerIcon__VuRcv { color: white; }

@keyframes AssessmentPage_pulse__vLf-B {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.AssessmentPage_topBarRight__9W8Js { display: flex; align-items: center; }
.AssessmentPage_userLabel__k8b-u { font-size: 0.78rem; color: var(--green); background: var(--green-light); padding: 0.4rem 0.75rem; border-radius: 4px; font-weight: 500; }

/* Progress */
.AssessmentPage_progressOuter__9VIpP { height: 3px; background: var(--gray-100); }
.AssessmentPage_progressInner__yDRY\\+ { height: 100%; background: var(--green); transition: width 0.4s ease; }

/* Camera Feed */
.AssessmentPage_cameraCard__KTh9v {
  position: fixed;
  bottom: auto;
  left: auto;
  right: 0;
  top: 155px;
  width: 180px;
  height: 140px;
  background: white;
  border: 2px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  z-index: 40;
  -webkit-user-select: none;
          user-select: none;
  transition: none;
}

.AssessmentPage_cameraLabel__8Xhzs {
  background: var(--red);
  color: white;
  padding: 0.4rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
}

.AssessmentPage_cameraVideo__9E0ca {
  flex: 1 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: var(--gray-900);
}

/* Tabs */
.AssessmentPage_tabs__sDeyh {
  background: white;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.25rem;
  gap: 1rem;
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  z-index: 49;
}

.AssessmentPage_tabsContainer__yfAWv {
  display: flex;
  overflow-x: auto;
  scrollbar-width: none;
  flex: 1 1;
}
.AssessmentPage_tabsContainer__yfAWv::-webkit-scrollbar { display: none; }

.AssessmentPage_tab__b3q4R {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.65rem 1.1rem;
  border: none;
  background: transparent;
  color: var(--gray-500);
  font-size: 0.8rem;
  font-weight: 400;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.12s, border-color 0.12s;
  position: relative;
}
.AssessmentPage_tab__b3q4R:hover { color: var(--gray-900); }
.AssessmentPage_tabActive__3EXCE { color: var(--red); font-weight: 500; border-bottom-color: var(--red); }
.AssessmentPage_tabDone__4R7Sc { color: var(--green); }
.AssessmentPage_tabDone__4R7Sc.AssessmentPage_tabActive__3EXCE { border-bottom-color: var(--green); }

.AssessmentPage_tabCheck__zg5h2 { font-size: 0.65rem; color: var(--green); }
.AssessmentPage_tabCount__AgZjn {
  font-size: 0.68rem;
  color: var(--gray-400);
  background: var(--gray-100);
  padding: 1px 5px;
  border-radius: 10px;
}
.AssessmentPage_tabActive__3EXCE .AssessmentPage_tabCount__AgZjn { background: var(--gray-100); }

.AssessmentPage_tabSubmitBtn__K6xeh {
  padding: 0.55rem 1.25rem;
  background: var(--red);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  flex-shrink: 0;
}
.AssessmentPage_tabSubmitBtn__K6xeh:hover:not(:disabled) {
  background: var(--red-dark);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.2);
}
.AssessmentPage_tabSubmitBtn__K6xeh:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Main */
.AssessmentPage_main__irc5G {
  flex: 1 1;
  max-width: 780px;
  width: 100%;
  margin: 0 auto;
  margin-top: 48px;
  padding: 1.5rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}
.AssessmentPage_mainBlurred__eU5rA {
  filter: blur(5px);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.AssessmentPage_sectionHeader__L-SkZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.AssessmentPage_sectionBadge__hN4p9 {
  display: inline-block;
  padding: 3px 10px;
  background: var(--red);
  color: white;
  border-radius: 4px;
  font-size: 0.68rem;
  font-weight: 600;
  letter-spacing: 0.05em;
}

.AssessmentPage_qCount__brk5e { font-size: 0.78rem; color: var(--gray-500); }

.AssessmentPage_loading__Gv-Up { padding: 2rem; text-align: center; color: var(--gray-500); font-size: 0.85rem; }

/* Scenario Card Styles (Case Study) */
.AssessmentPage_scenarioCardHeader__XbeKY {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #d4e8f7;
}

.AssessmentPage_scenarioBadge__nnXgo {
  display: inline-block;
  padding: 0.35rem 0.75rem;
  background: #0369a1;
  color: white;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  flex-shrink: 0;
}

.AssessmentPage_scenarioTitle__UcK3h {
  font-size: 1rem;
  font-weight: 600;
  color: #0369a1;
}

.AssessmentPage_scenarioCardContent__HWzms {
  font-size: 0.85rem;
  color: var(--gray-800);
  line-height: 1.7;
  margin-bottom: 1.25rem;
  padding: 1.25rem;
  background: #f0f7ff;
  border-radius: var(--radius);
  border-left: 4px solid #0369a1;
  max-height: 500px;
  overflow-y: auto;
}

.AssessmentPage_scenarioCardContent__HWzms::-webkit-scrollbar {
  width: 6px;
}

.AssessmentPage_scenarioCardContent__HWzms::-webkit-scrollbar-track {
  background: transparent;
}

.AssessmentPage_scenarioCardContent__HWzms::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.AssessmentPage_scenarioCardContent__HWzms::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.AssessmentPage_scenarioCardFooter__zaVpy {
  font-size: 0.78rem;
  color: #0284c7;
  font-style: italic;
  padding: 0.75rem 1rem;
  background: #f9fcff;
  border-radius: var(--radius);
  border: 1px solid #d4e8f7;
}

.AssessmentPage_accessBlockedPage__e44N1 {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: var(--gray-50);
}

.AssessmentPage_accessBlockedCard__kJ\\+sM {
  width: 100%;
  max-width: 460px;
  padding: 2rem;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  background: white;
  box-shadow: var(--shadow-lg);
  text-align: center;
}

.AssessmentPage_accessBlockedIcon__lEoVf {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin: 0 auto 1rem;
  border-radius: 50%;
  background: #fff7ed;
  color: #c2410c;
  font-size: 1.4rem;
}

.AssessmentPage_accessBlockedTitle__uNbL6 {
  margin: 0 0 0.75rem;
  color: var(--gray-900);
  font-size: 1.2rem;
}

.AssessmentPage_accessBlockedMessage__LXgCF {
  margin: 0;
  color: var(--gray-700);
  font-size: 0.9rem;
  line-height: 1.6;
}

.AssessmentPage_accessBlockedWait__5cD8m {
  margin: 1rem 0 0;
  color: var(--gray-500);
  font-size: 0.78rem;
}

/* Scenario Card Wrapper - Table Format */
.AssessmentPage_scenarioCardWrapper__Wfrh1 {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  animation: AssessmentPage_fadeIn__Ncd9i 0.2s ease;
  margin-bottom: 1.5rem;
}

.AssessmentPage_scenarioHeader__Lk0YN {
  background: #c41e3a;
  color: white;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #a01830;
}

.AssessmentPage_scenarioHeaderTitle__pPPX5 {
  font-size: 1.1rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  letter-spacing: 0.5px;
}

.AssessmentPage_scenarioHeaderSubtitle__qhuLt {
  font-size: 0.85rem;
  margin: 0;
  opacity: 0.95;
}

.AssessmentPage_scenarioBody__NvMFS {
  padding: 1.5rem;
}

.AssessmentPage_scenarioBody__NvMFS > p {
  font-size: 0.9rem;
  color: var(--gray-700);
  margin-bottom: 1.25rem;
  line-height: 1.6;
}

/* KPI Data Table */
.AssessmentPage_kpiTable__8IAbk {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
  font-size: 0.85rem;
}

.AssessmentPage_kpiTable__8IAbk thead {
  background: #2d2d2d;
  color: white;
}

.AssessmentPage_kpiTable__8IAbk th {
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  border: 1px solid #2d2d2d;
}

.AssessmentPage_kpiTable__8IAbk td {
  padding: 0.75rem;
  border: 1px solid #e5e5e5;
  color: var(--gray-800);
}

.AssessmentPage_kpiTable__8IAbk tbody tr:nth-child(even) {
  background: #f9f9f9;
}

.AssessmentPage_kpiTable__8IAbk tbody tr:hover {
  background: #f5f5f5;
}

.AssessmentPage_kpiTable__8IAbk td.AssessmentPage_percentOrange__F90M7 {
  color: #d97706 !important;
  font-weight: 500;
}

.AssessmentPage_kpiTable__8IAbk td.AssessmentPage_percentRed__AFiN3 {
  color: #dc2626 !important;
  font-weight: 500;
}

.AssessmentPage_kpiTable__8IAbk td.AssessmentPage_percentGreen__xunrj {
  color: #16a34a !important;
  font-weight: 500;
}

/* Contextual Notes */
.AssessmentPage_contextualNotes__bgrO0 {
  border-top: 1px solid #e5e5e5;
  padding-top: 1.25rem;
}

.AssessmentPage_contextualNotesTitle__f05eg {
  font-size: 0.85rem;
  font-weight: 600;
  color: #059669;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 0 0 0.75rem 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.AssessmentPage_contextualNotesTitle__f05eg::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 4px;
  background: #059669;
  border-radius: 50%;
}

.AssessmentPage_contextualNotesList__cbM9I {
  list-style: none;
  padding: 0;
  margin: 0;
}

.AssessmentPage_contextualNotesList__cbM9I li {
  padding: 0.5rem 0 0.5rem 1.5rem;
  font-size: 0.85rem;
  color: var(--gray-800);
  line-height: 1.5;
  position: relative;
}

.AssessmentPage_contextualNotesList__cbM9I li::before {
  content: '•';
  position: absolute;
  left: 0.5rem;
  color: #059669;
  font-weight: bold;
}

/* Question Card */
.AssessmentPage_questionCard__74PTR {
  background: white;
  border: 1px solid var(--border);
  border-top: 3px solid var(--green-mid);
  border-radius: var(--radius-lg);
  padding: 1.5rem;
  animation: AssessmentPage_fadeIn__Ncd9i 0.2s ease;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.AssessmentPage_questionText__TXxdV {
  font-size: 0.9rem;
  color: var(--gray-900);
  line-height: 1.65;
  margin-bottom: 1.25rem;
}

.AssessmentPage_qNum__wWSWS { font-weight: 600; color: var(--gray-500); }

/* Options */
.AssessmentPage_options__lidJo { display: flex; flex-direction: column; gap: 0.5rem; }

.AssessmentPage_option__pXNFw {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.7rem 0.9rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: white;
  text-align: left;
  transition: all 0.12s;
  width: 100%;
}
.AssessmentPage_option__pXNFw:hover { border-color: var(--gray-400); background: var(--gray-50); }
.AssessmentPage_optionSelected__xwTg8 { border-color: var(--green) !important; background: var(--green-light) !important; }

.AssessmentPage_optionLabel__meQkF {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--gray-500);
  flex-shrink: 0;
  width: 18px;
}
.AssessmentPage_optionSelected__xwTg8 .AssessmentPage_optionLabel__meQkF { color: var(--green); }
.AssessmentPage_optionText__khvuG { font-size: 0.85rem; color: var(--gray-800); line-height: 1.5; }

/* Likert */
.AssessmentPage_likertWrap__KEBYb { display: flex; flex-direction: column; gap: 1.25rem; }

.AssessmentPage_likertScale__oxcyQ {
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: flex-end;
}

.AssessmentPage_likertOption__JssWm {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
}

.AssessmentPage_likertLabel__45pZ1 {
  font-size: 0.75rem;
  color: var(--gray-600);
  font-weight: 500;
  text-align: center;
  min-width: 52px;
}

.AssessmentPage_likertBtn__3Ecz- {
  width: 52px;
  height: 52px;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: white;
  font-size: 1rem;
  font-weight: 500;
  color: var(--gray-700);
  transition: all 0.12s;
}
.AssessmentPage_likertBtn__3Ecz-:hover { border-color: var(--gray-400); background: var(--gray-50); }
.AssessmentPage_likertSelected__V1fH4 { border-color: var(--green) !important; background: var(--green) !important; color: white !important; }

.AssessmentPage_likertMsg__oeKeR { font-size: 0.8rem; color: var(--gray-400); text-align: center; min-height: 1.2rem; }

.AssessmentPage_optionMsg__17dNq { font-size: 0.8rem; color: var(--gray-400); text-align: center; min-height: 1.2rem; margin-top: 0.5rem; }

.AssessmentPage_openMsg__wtEPT { font-size: 0.8rem; color: var(--gray-400); text-align: center; min-height: 1.2rem; }

/* Open */
.AssessmentPage_openWrap__dNEgq { display: flex; flex-direction: column; gap: 0.4rem; }
.AssessmentPage_textarea__4UB-r {
  width: 100%;
  padding: 0.85rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.85rem;
  color: var(--gray-900);
  line-height: 1.6;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s;
  font-family: inherit;
}
.AssessmentPage_textarea__4UB-r:focus { border-color: var(--green); }
.AssessmentPage_charCount__NzaxM { font-size: 0.7rem; color: var(--gray-400); text-align: right; }

/* Navigation */
.AssessmentPage_navRow__IQHcM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.AssessmentPage_navBtn__giaIj {
  padding: 0.5rem 1rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: white;
  font-size: 0.82rem;
  color: var(--gray-700);
  transition: all 0.12s;
  min-width: 80px;
}
.AssessmentPage_navBtn__giaIj:hover:not(:disabled) { background: var(--gray-50); }
.AssessmentPage_navBtn__giaIj:disabled { opacity: 0.35; cursor: not-allowed; }

.AssessmentPage_navBtnPrimary__a0EI7 {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: var(--radius);
  background: var(--red);
  color: white;
  font-size: 0.82rem;
  font-weight: 500;
  transition: background 0.12s;
  min-width: 80px;
}
.AssessmentPage_navBtnPrimary__a0EI7:hover { background: var(--red-dark); }
.AssessmentPage_navBtnPrimary__a0EI7:disabled { opacity: 0.35; cursor: not-allowed; }

/* Submit Actions Row */
.AssessmentPage_actionsRow__8CarW {
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  padding: 1rem;
  background: var(--gray-50);
  border-top: 1px solid var(--border);
  margin-top: 1rem;
}

.AssessmentPage_actionBtn__DrWzI {
  padding: 0.65rem 1.25rem;
  border: none;
  border-radius: var(--radius);
  background: var(--green);
  color: white;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.AssessmentPage_actionBtn__DrWzI:hover:not(:disabled) {
  background: #155a30;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(26, 92, 56, 0.2);
}
.AssessmentPage_actionBtn__DrWzI:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.AssessmentPage_navCenter__bfpL9 {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
  flex: 1 1;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}

.AssessmentPage_navDot__OfHxM {
  width: 32px; height: 32px;
  border-radius: 4px;
  border: 1.5px solid var(--border);
  background: white;
  padding: 0;
  transition: all 0.1s;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--gray-700);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.AssessmentPage_navDotScenario__WxaoO {
  width: auto;
  padding: 0 0.75rem;
}

.AssessmentPage_navDotActive__JsJDz { border-color: var(--red); background: var(--red); color: white; }
.AssessmentPage_navDotAnswered__mgoko { border-color: var(--green); background: var(--green-light); color: var(--green); font-weight: 700; }
.AssessmentPage_navDotActive__JsJDz.AssessmentPage_navDotAnswered__mgoko { background: var(--green); border-color: var(--green); color: white; }

/* Submit */
.AssessmentPage_submitArea__wUdE6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.25rem;
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  gap: 1rem;
  flex-wrap: wrap;
}

.AssessmentPage_submitInfo__5kWaW { font-size: 0.78rem; color: var(--gray-500); }

.AssessmentPage_submitBtn__Rz2o4 {
  padding: 0.6rem 1.5rem;
  background: var(--red);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 500;
  transition: background 0.15s, opacity 0.15s;
  white-space: nowrap;
}
.AssessmentPage_submitBtn__Rz2o4:hover:not(:disabled) { background: var(--red-dark); }
.AssessmentPage_submitBtn__Rz2o4:disabled { opacity: 0.5; cursor: not-allowed; }

/* Submitted */
.AssessmentPage_submittedPage__OkOhO {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-50);
  padding: 1.5rem;
}

.AssessmentPage_submittedCard__mKhur {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 2.5rem 2rem;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow);
}

.AssessmentPage_submittedIcon__G3MLS {
  width: 52px; height: 52px;
  border-radius: 50%;
  background: var(--green-light);
  color: var(--green);
  font-size: 1.4rem;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.25rem;
}

.AssessmentPage_submittedTitle__p2x2h { font-size: 1.3rem; color: var(--black); margin-bottom: 0.65rem; }
.AssessmentPage_submittedSub__bK3Ix { font-size: 0.85rem; color: var(--gray-700); line-height: 1.6; margin-bottom: 0.85rem; }
.AssessmentPage_submittedNote__qg3\\+b { font-size: 0.78rem; color: var(--gray-500); line-height: 1.6; margin-bottom: 1.5rem; }
.AssessmentPage_countdownText__dwwf9 { font-size: 0.85rem; color: var(--gray-600); margin-bottom: 1.5rem; font-weight: 500; }
.AssessmentPage_countdownNumber__Hr2\\+i { font-size: 1.1rem; font-weight: 700; color: var(--green); }
.AssessmentPage_submittedBtn__v06gT {
  padding: 0.65rem 1.5rem;
  background: var(--green);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 500;
}
.AssessmentPage_submittedBtn__v06gT:hover { background: #155a30; }

/* Section Transition */
.AssessmentPage_transitionPage__t\\+y2Q {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-50);
  padding: 1.5rem;
}

.AssessmentPage_transitionCard__jSRv3 {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 2.5rem 2rem;
  max-width: 420px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow);
  border-top: 3px solid var(--green-mid);
}

.AssessmentPage_transitionIcon__qKbxd {
  width: 52px; height: 52px;
  border-radius: 50%;
  background: var(--green-light);
  color: var(--green);
  font-size: 1.4rem;
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.25rem;
}

.AssessmentPage_transitionTitle__22JBM { font-size: 1rem; color: var(--gray-500); margin-bottom: 0.5rem; font-weight: 400; letter-spacing: 0.05em; }
.AssessmentPage_transitionSectionName__Suudi { font-size: 1.3rem; color: var(--black); margin-bottom: 1.25rem; font-weight: 600; }
.AssessmentPage_transitionDesc__HE\\+FN { font-size: 0.85rem; color: var(--gray-700); line-height: 1.65; margin-bottom: 1.5rem; }
.AssessmentPage_transitionMeta__28-6B { background: var(--gray-50); padding: 1rem; border-radius: var(--radius); margin-bottom: 1.5rem; }
.AssessmentPage_transitionCount__gDZi1 { font-size: 0.85rem; color: var(--green); font-weight: 500; margin-bottom: 0.5rem; }
.AssessmentPage_transitionCompleted__CchLL { font-size: 0.8rem; color: var(--green); }

.AssessmentPage_continueBtn__bjHdC {
  padding: 0.65rem 2rem;
  background: var(--green);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  transition: background 0.15s;
  width: 100%;
}
.AssessmentPage_continueBtn__bjHdC:hover { background: var(--green-mid); }

/* Submit Confirmation Modal */
.AssessmentPage_modalOverlay__AFguV {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.AssessmentPage_modalCard__5grVz {
  background: white;
  border-radius: var(--radius-lg);
  padding: 2rem;
  max-width: 380px;
  width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  animation: AssessmentPage_modalSlideIn__elJmG 0.2s ease;
}

.AssessmentPage_modalTitle__X8cl6 {
  font-size: 1.15rem;
  color: var(--gray-900);
  margin-bottom: 0.75rem;
  font-weight: 600;
}

.AssessmentPage_modalMessage__2wrHE {
  font-size: 0.85rem;
  color: var(--gray-600);
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.AssessmentPage_modalActions__HQKTr {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
}

.AssessmentPage_warningList__dyLb\\+ {
  background: var(--red-light);
  border: 1px solid #fca5a5;
  border-radius: var(--radius);
  padding: 1rem;
  margin: 1rem 0 1.5rem 0;
}

.AssessmentPage_warningItem__JhRGG {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  font-size: 0.9rem;
  color: var(--gray-800);
}

.AssessmentPage_warningItem__JhRGG:not(:last-child) {
  border-bottom: 1px solid rgba(220, 38, 38, 0.2);
}

.AssessmentPage_warningItem__JhRGG strong {
  color: var(--red);
  font-weight: 600;
}

.AssessmentPage_modalBtnCancel__HrbUe {
  padding: 0.55rem 1.25rem;
  background: var(--gray-100);
  color: var(--gray-700);
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 500;
  transition: background 0.15s;
}
.AssessmentPage_modalBtnCancel__HrbUe:hover:not(:disabled) { background: var(--gray-200); }
.AssessmentPage_modalBtnCancel__HrbUe:disabled { opacity: 0.5; cursor: not-allowed; }

.AssessmentPage_modalBtnSubmit__x7Led {
  padding: 0.55rem 1.25rem;
  background: var(--red);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 500;
  transition: background 0.15s;
}
.AssessmentPage_modalBtnSubmit__x7Led:hover:not(:disabled) { background: var(--red-dark); }
.AssessmentPage_modalBtnSubmit__x7Led:disabled { opacity: 0.5; cursor: not-allowed; }

/* Animations */
@keyframes AssessmentPage_fadeIn__Ncd9i {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes AssessmentPage_modalSlideIn__elJmG {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Skeleton Loaders */
@keyframes AssessmentPage_shimmer__Rvpmw {
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
}

.AssessmentPage_skeletonQuestionText__vumFn {
  height: 24px;
  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);
  background-size: 1000px 100%;
  animation: AssessmentPage_shimmer__Rvpmw 2s infinite;
  border-radius: 6px;
  margin-bottom: 1.5rem;
}

.AssessmentPage_skeletonOptions__xuf5O {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.AssessmentPage_skeletonOption__sktIo {
  height: 56px;
  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);
  background-size: 1000px 100%;
  animation: AssessmentPage_shimmer__Rvpmw 2s infinite;
  border-radius: var(--radius);
  border: 1px solid var(--border);
}

.AssessmentPage_skeletonLikert__4sT3U {
  height: 120px;
  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);
  background-size: 1000px 100%;
  animation: AssessmentPage_shimmer__Rvpmw 2s infinite;
  border-radius: var(--radius);
}

.AssessmentPage_skeletonTextarea__1djA5 {
  height: 240px;
  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);
  background-size: 1000px 100%;
  animation: AssessmentPage_shimmer__Rvpmw 2s infinite;
  border-radius: var(--radius);
  border: 1px solid var(--border);
}

/* Submission In Progress Overlay */
.AssessmentPage_submissionOverlay__lZxNf {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  pointer-events: all;
}

.AssessmentPage_submissionSpinner__UVsVU {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}

.AssessmentPage_spinner__cqGTA {
  width: 48px;
  height: 48px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: AssessmentPage_spin__c\\+LPT 0.8s linear infinite;
}

@keyframes AssessmentPage_spin__c\\+LPT {
  to { transform: rotate(360deg); }
}

.AssessmentPage_submissionSpinner__UVsVU p {
  color: white;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.03em;
}

.AssessmentPage_loadingSpinner__KZoKU {
  width: 48px;
  height: 48px;
  border: 3px solid var(--gray-200);
  border-top-color: var(--green);
  border-radius: 50%;
  margin: 2rem auto 0;
  animation: AssessmentPage_spin__c\\+LPT 1.2s linear infinite;
}

@media (max-width: 600px) {
  .AssessmentPage_topBarTitle__iSfL0 { display: none; }
  .AssessmentPage_userLabel__k8b-u { display: none; }
  .AssessmentPage_main__irc5G { padding: 1rem 0.85rem; }
  .AssessmentPage_questionCard__74PTR { padding: 1.1rem; }
  .AssessmentPage_likertBtn__3Ecz- { width: 44px; height: 44px; font-size: 0.9rem; }
  .AssessmentPage_navCenter__bfpL9 { max-height: 44px; }
  .AssessmentPage_navDot__OfHxM { width: 28px; height: 28px; font-size: 0.7rem; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/assessment/AssessmentPage.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA,oCAAc,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA,qCAAe,kBAAkB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;;AAE7E,wBAAwB;AACxB;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA,sCAAgB,aAAa,EAAE,mBAAmB,EAAE;AACpD;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW;EAC/C,sBAAsB;EACtB,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;AACA,mCAAa,wBAAwB,EAAE,4BAA4B,EAAE;AACrE,mCAAa,eAAe,EAAE;AAC9B,kCAAY,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,kCAAkC,EAAE,sBAAsB,EAAE;AACrI,mEAAuB,iBAAiB,EAAE;AAC1C,uCAAgB,wBAAwB,EAAE,sBAAsB,EAAE,kDAA4B,EAAE;AAChG,uEAA0B,YAAY,EAAE;AACxC,wEAA2B,YAAY,EAAE;;AAEzC;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA,qCAAe,aAAa,EAAE,mBAAmB,EAAE;AACnD,mCAAa,kBAAkB,EAAE,mBAAmB,EAAE,8BAA8B,EAAE,uBAAuB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAErJ,aAAa;AACb,uCAAiB,WAAW,EAAE,2BAA2B,EAAE;AAC3D,wCAAiB,YAAY,EAAE,wBAAwB,EAAE,2BAA2B,EAAE;;AAEtF,gBAAgB;AAChB;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,SAAO;AACT;AACA,0DAAoC,aAAa,EAAE;;AAEnD;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;AACA,mCAAa,sBAAsB,EAAE;AACrC,mCAAa,iBAAiB,EAAE,gBAAgB,EAAE,+BAA+B,EAAE;AACnF,iCAAW,mBAAmB,EAAE;AAChC,iEAAqB,iCAAiC,EAAE;;AAExD,kCAAY,kBAAkB,EAAE,mBAAmB,EAAE;AACrD;EACE,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;AACA,mEAAuB,2BAA2B,EAAE;;AAEpD;EACE,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,SAAO;EACP,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,gCAAU,kBAAkB,EAAE,sBAAsB,EAAE;;AAEtD,iCAAW,aAAa,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE;;AAE1F,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,iDAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,eAAe;EACf,iDAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8BAAQ,gBAAgB,EAAE,sBAAsB,EAAE;;AAElD,YAAY;AACZ,iCAAW,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;;AAE/D;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;AACA,sCAAgB,6BAA6B,EAAE,0BAA0B,EAAE;AAC3E,wCAAkB,qCAAqC,EAAE,yCAAyC,EAAE;;AAEpG;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,WAAW;AACb;AACA,2EAA+B,mBAAmB,EAAE;AACpD,oCAAc,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;;AAE5E,WAAW;AACX,oCAAc,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;;AAEnE;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;AACA,yCAAmB,6BAA6B,EAAE,0BAA0B,EAAE;AAC9E,wCAAkB,qCAAqC,EAAE,mCAAmC,EAAE,uBAAuB,EAAE;;AAEvH,mCAAa,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;;AAEhG,mCAAa,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;;AAEpH,iCAAW,iBAAiB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;;AAE9F,SAAS;AACT,kCAAY,aAAa,EAAE,sBAAsB,EAAE,WAAW,EAAE;AAChE;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;AACtB;AACA,wCAAkB,0BAA0B,EAAE;AAC9C,mCAAa,iBAAiB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE;;AAE3E,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;AACA,qDAA+B,0BAA0B,EAAE;AAC3D,yCAAmB,aAAa,EAAE,mBAAmB,EAAE;;AAEvD;EACE,oBAAoB;EACpB,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;AACA,6CAAuB,2BAA2B,EAAE;AACpD,gDAA0B,aAAa,EAAE,mBAAmB,EAAE;;AAE9D,uBAAuB;AACvB;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,aAAa;EACb,0BAA0B;EAC1B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,4BAA4B;EAC5B,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA,sCAAgB,wBAAwB,EAAE,sBAAsB,EAAE,YAAY,EAAE;AAChF,wCAAkB,0BAA0B,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;AACrH,2EAA+B,wBAAwB,EAAE,0BAA0B,EAAE,YAAY,EAAE;;AAEnG,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,SAAS;EACT,eAAe;AACjB;;AAEA,oCAAc,kBAAkB,EAAE,sBAAsB,EAAE;;AAE1D;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;AACrB;AACA,wDAAkC,2BAA2B,EAAE;AAC/D,4CAAsB,YAAY,EAAE,mBAAmB,EAAE;;AAEzD,cAAc;AACd;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,sBAAsB;AACxB;;AAEA,wCAAkB,iBAAiB,EAAE,mBAAmB,EAAE,sBAAsB,EAAE;AAClF,sCAAgB,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AACtG,wCAAiB,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACtG,uCAAiB,kBAAkB,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AACtG,0CAAmB,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC7E;EACE,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;AACA,4CAAsB,mBAAmB,EAAE;;AAE3C,uBAAuB;AACvB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,sBAAsB;AACxB;;AAEA,yCAAmB,eAAe,EAAE,sBAAsB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAC7H,+CAAyB,iBAAiB,EAAE,mBAAmB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC3G,yCAAkB,kBAAkB,EAAE,sBAAsB,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACxG,wCAAkB,0BAA0B,EAAE,aAAa,EAAE,4BAA4B,EAAE,qBAAqB,EAAE;AAClH,yCAAmB,kBAAkB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;AACrG,6CAAuB,iBAAiB,EAAE,mBAAmB,EAAE;;AAE/D;EACE,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;AACb;AACA,2CAAqB,4BAA4B,EAAE;;AAEnD,8BAA8B;AAC9B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,uDAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,6DAAuC,2BAA2B,EAAE;AACpE,iDAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D;EACE,wBAAwB;EACxB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;AACA,6DAAuC,2BAA2B,EAAE;AACpE,iDAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,KAAK,8BAA8B,EAAE;EACrC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,YAAY;EACZ,iGAAiG;EACjG,4BAA4B;EAC5B,oDAA8B;EAC9B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iGAAiG;EACjG,4BAA4B;EAC5B,oDAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iGAAiG;EACjG,4BAA4B;EAC5B,oDAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iGAAiG;EACjG,4BAA4B;EAC5B,oDAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,uBAAuB;EACvB,kBAAkB;EAClB,2DAAoC;AACtC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,2DAAoC;AACtC;;AAEA;EACE,qCAAe,aAAa,EAAE;EAC9B,mCAAa,aAAa,EAAE;EAC5B,8BAAQ,qBAAqB,EAAE;EAC/B,sCAAgB,eAAe,EAAE;EACjC,mCAAa,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;EAC3D,mCAAa,gBAAgB,EAAE;EAC/B,gCAAU,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE;AAC1D","sourcesContent":[".page {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--gray-50);\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  padding-top: 48px;\n}\n\n/* Top Bar */\n.topBar {\n  height: 48px;\n  background: white;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.25rem;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n}\n\n.topBarLeft { display: flex; align-items: center; gap: 0.65rem; }\n.logoMark {\n  width: 32px;\n  height: auto;\n  flex-shrink: 0;\n}\n.topBarTitle { font-size: 0.78rem; font-weight: 500; color: var(--gray-700); }\n\n/* Time Expired Banner */\n.timeExpiredBanner {\n  background: var(--red);\n  color: white;\n  padding: 0.75rem 1rem;\n  text-align: center;\n  position: fixed;\n  top: 48px;\n  left: 0;\n  right: 0;\n  z-index: 49;\n}\n.timeExpiredContent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.timeExpiredIcon {\n  font-size: 1.5rem;\n}\n.timeExpiredText {\n  font-size: 0.95rem;\n}\n.timeExpiredText strong {\n  font-size: 1.1rem;\n}\n\n.topBarCenter { display: flex; align-items: center; }\n.timer {\n  display: flex; align-items: center; gap: 0.5rem;\n  padding: 0.5rem 1.1rem;\n  border: 2px solid var(--border);\n  border-radius: 100px;\n  background: white;\n  transition: all 0.3s;\n}\n.timerWarn { border-color: var(--red); background: var(--red-light); }\n.timerIcon { font-size: 1rem; }\n.timerVal { font-size: 1.1rem; font-weight: 700; color: var(--gray-900); font-variant-numeric: tabular-nums; letter-spacing: 0.02em; }\n.timerWarn .timerVal { color: var(--red); }\n.timerExpired { border-color: var(--red); background: var(--red); animation: pulse 1s infinite; }\n.timerExpired .timerVal { color: white; }\n.timerExpired .timerIcon { color: white; }\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.topBarRight { display: flex; align-items: center; }\n.userLabel { font-size: 0.78rem; color: var(--green); background: var(--green-light); padding: 0.4rem 0.75rem; border-radius: 4px; font-weight: 500; }\n\n/* Progress */\n.progressOuter { height: 3px; background: var(--gray-100); }\n.progressInner { height: 100%; background: var(--green); transition: width 0.4s ease; }\n\n/* Camera Feed */\n.cameraCard {\n  position: fixed;\n  bottom: auto;\n  left: auto;\n  right: 0;\n  top: 155px;\n  width: 180px;\n  height: 140px;\n  background: white;\n  border: 2px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  flex-direction: column;\n  z-index: 40;\n  user-select: none;\n  transition: none;\n}\n\n.cameraLabel {\n  background: var(--red);\n  color: white;\n  padding: 0.4rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.cameraVideo {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: var(--gray-900);\n}\n\n/* Tabs */\n.tabs {\n  background: white;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 1.25rem;\n  gap: 1rem;\n  position: fixed;\n  top: 48px;\n  left: 0;\n  right: 0;\n  z-index: 49;\n}\n\n.tabsContainer {\n  display: flex;\n  overflow-x: auto;\n  scrollbar-width: none;\n  flex: 1;\n}\n.tabsContainer::-webkit-scrollbar { display: none; }\n\n.tab {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.65rem 1.1rem;\n  border: none;\n  background: transparent;\n  color: var(--gray-500);\n  font-size: 0.8rem;\n  font-weight: 400;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n  transition: color 0.12s, border-color 0.12s;\n  position: relative;\n}\n.tab:hover { color: var(--gray-900); }\n.tabActive { color: var(--red); font-weight: 500; border-bottom-color: var(--red); }\n.tabDone { color: var(--green); }\n.tabDone.tabActive { border-bottom-color: var(--green); }\n\n.tabCheck { font-size: 0.65rem; color: var(--green); }\n.tabCount {\n  font-size: 0.68rem;\n  color: var(--gray-400);\n  background: var(--gray-100);\n  padding: 1px 5px;\n  border-radius: 10px;\n}\n.tabActive .tabCount { background: var(--gray-100); }\n\n.tabSubmitBtn {\n  padding: 0.55rem 1.25rem;\n  background: var(--red);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n.tabSubmitBtn:hover:not(:disabled) {\n  background: var(--red-dark);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(220, 38, 38, 0.2);\n}\n.tabSubmitBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Main */\n.main {\n  flex: 1;\n  max-width: 780px;\n  width: 100%;\n  margin: 0 auto;\n  margin-top: 48px;\n  padding: 1.5rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.1rem;\n}\n.mainBlurred {\n  filter: blur(5px);\n  pointer-events: none;\n  user-select: none;\n}\n\n.sectionHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sectionBadge {\n  display: inline-block;\n  padding: 3px 10px;\n  background: var(--red);\n  color: white;\n  border-radius: 4px;\n  font-size: 0.68rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n}\n\n.qCount { font-size: 0.78rem; color: var(--gray-500); }\n\n.loading { padding: 2rem; text-align: center; color: var(--gray-500); font-size: 0.85rem; }\n\n/* Scenario Card Styles (Case Study) */\n.scenarioCardHeader {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 1.25rem;\n  padding-bottom: 1rem;\n  border-bottom: 2px solid #d4e8f7;\n}\n\n.scenarioBadge {\n  display: inline-block;\n  padding: 0.35rem 0.75rem;\n  background: #0369a1;\n  color: white;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  flex-shrink: 0;\n}\n\n.scenarioTitle {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #0369a1;\n}\n\n.scenarioCardContent {\n  font-size: 0.85rem;\n  color: var(--gray-800);\n  line-height: 1.7;\n  margin-bottom: 1.25rem;\n  padding: 1.25rem;\n  background: #f0f7ff;\n  border-radius: var(--radius);\n  border-left: 4px solid #0369a1;\n  max-height: 500px;\n  overflow-y: auto;\n}\n\n.scenarioCardContent::-webkit-scrollbar {\n  width: 6px;\n}\n\n.scenarioCardContent::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scenarioCardContent::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.scenarioCardContent::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n.scenarioCardFooter {\n  font-size: 0.78rem;\n  color: #0284c7;\n  font-style: italic;\n  padding: 0.75rem 1rem;\n  background: #f9fcff;\n  border-radius: var(--radius);\n  border: 1px solid #d4e8f7;\n}\n\n.accessBlockedPage {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1.5rem;\n  background: var(--gray-50);\n}\n\n.accessBlockedCard {\n  width: 100%;\n  max-width: 460px;\n  padding: 2rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  background: white;\n  box-shadow: var(--shadow-lg);\n  text-align: center;\n}\n\n.accessBlockedIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  margin: 0 auto 1rem;\n  border-radius: 50%;\n  background: #fff7ed;\n  color: #c2410c;\n  font-size: 1.4rem;\n}\n\n.accessBlockedTitle {\n  margin: 0 0 0.75rem;\n  color: var(--gray-900);\n  font-size: 1.2rem;\n}\n\n.accessBlockedMessage {\n  margin: 0;\n  color: var(--gray-700);\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n\n.accessBlockedWait {\n  margin: 1rem 0 0;\n  color: var(--gray-500);\n  font-size: 0.78rem;\n}\n\n/* Scenario Card Wrapper - Table Format */\n.scenarioCardWrapper {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  animation: fadeIn 0.2s ease;\n  margin-bottom: 1.5rem;\n}\n\n.scenarioHeader {\n  background: #c41e3a;\n  color: white;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid #a01830;\n}\n\n.scenarioHeaderTitle {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin: 0 0 0.25rem 0;\n  letter-spacing: 0.5px;\n}\n\n.scenarioHeaderSubtitle {\n  font-size: 0.85rem;\n  margin: 0;\n  opacity: 0.95;\n}\n\n.scenarioBody {\n  padding: 1.5rem;\n}\n\n.scenarioBody > p {\n  font-size: 0.9rem;\n  color: var(--gray-700);\n  margin-bottom: 1.25rem;\n  line-height: 1.6;\n}\n\n/* KPI Data Table */\n.kpiTable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 1.5rem;\n  font-size: 0.85rem;\n}\n\n.kpiTable thead {\n  background: #2d2d2d;\n  color: white;\n}\n\n.kpiTable th {\n  padding: 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  border: 1px solid #2d2d2d;\n}\n\n.kpiTable td {\n  padding: 0.75rem;\n  border: 1px solid #e5e5e5;\n  color: var(--gray-800);\n}\n\n.kpiTable tbody tr:nth-child(even) {\n  background: #f9f9f9;\n}\n\n.kpiTable tbody tr:hover {\n  background: #f5f5f5;\n}\n\n.kpiTable td.percentOrange {\n  color: #d97706 !important;\n  font-weight: 500;\n}\n\n.kpiTable td.percentRed {\n  color: #dc2626 !important;\n  font-weight: 500;\n}\n\n.kpiTable td.percentGreen {\n  color: #16a34a !important;\n  font-weight: 500;\n}\n\n/* Contextual Notes */\n.contextualNotes {\n  border-top: 1px solid #e5e5e5;\n  padding-top: 1.25rem;\n}\n\n.contextualNotesTitle {\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: #059669;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin: 0 0 0.75rem 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.contextualNotesTitle::before {\n  content: '';\n  display: inline-block;\n  width: 4px;\n  height: 4px;\n  background: #059669;\n  border-radius: 50%;\n}\n\n.contextualNotesList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.contextualNotesList li {\n  padding: 0.5rem 0 0.5rem 1.5rem;\n  font-size: 0.85rem;\n  color: var(--gray-800);\n  line-height: 1.5;\n  position: relative;\n}\n\n.contextualNotesList li::before {\n  content: '•';\n  position: absolute;\n  left: 0.5rem;\n  color: #059669;\n  font-weight: bold;\n}\n\n/* Question Card */\n.questionCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-top: 3px solid var(--green-mid);\n  border-radius: var(--radius-lg);\n  padding: 1.5rem;\n  animation: fadeIn 0.2s ease;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n}\n\n.questionText {\n  font-size: 0.9rem;\n  color: var(--gray-900);\n  line-height: 1.65;\n  margin-bottom: 1.25rem;\n}\n\n.qNum { font-weight: 600; color: var(--gray-500); }\n\n/* Options */\n.options { display: flex; flex-direction: column; gap: 0.5rem; }\n\n.option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0.7rem 0.9rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: white;\n  text-align: left;\n  transition: all 0.12s;\n  width: 100%;\n}\n.option:hover { border-color: var(--gray-400); background: var(--gray-50); }\n.optionSelected { border-color: var(--green) !important; background: var(--green-light) !important; }\n\n.optionLabel {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--gray-500);\n  flex-shrink: 0;\n  width: 18px;\n}\n.optionSelected .optionLabel { color: var(--green); }\n.optionText { font-size: 0.85rem; color: var(--gray-800); line-height: 1.5; }\n\n/* Likert */\n.likertWrap { display: flex; flex-direction: column; gap: 1.25rem; }\n\n.likertScale {\n  display: flex;\n  gap: 1rem;\n  justify-content: center;\n  align-items: flex-end;\n}\n\n.likertOption {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.likertLabel {\n  font-size: 0.75rem;\n  color: var(--gray-600);\n  font-weight: 500;\n  text-align: center;\n  min-width: 52px;\n}\n\n.likertBtn {\n  width: 52px;\n  height: 52px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: white;\n  font-size: 1rem;\n  font-weight: 500;\n  color: var(--gray-700);\n  transition: all 0.12s;\n}\n.likertBtn:hover { border-color: var(--gray-400); background: var(--gray-50); }\n.likertSelected { border-color: var(--green) !important; background: var(--green) !important; color: white !important; }\n\n.likertMsg { font-size: 0.8rem; color: var(--gray-400); text-align: center; min-height: 1.2rem; }\n\n.optionMsg { font-size: 0.8rem; color: var(--gray-400); text-align: center; min-height: 1.2rem; margin-top: 0.5rem; }\n\n.openMsg { font-size: 0.8rem; color: var(--gray-400); text-align: center; min-height: 1.2rem; }\n\n/* Open */\n.openWrap { display: flex; flex-direction: column; gap: 0.4rem; }\n.textarea {\n  width: 100%;\n  padding: 0.85rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  color: var(--gray-900);\n  line-height: 1.6;\n  resize: vertical;\n  outline: none;\n  transition: border-color 0.15s;\n  font-family: inherit;\n}\n.textarea:focus { border-color: var(--green); }\n.charCount { font-size: 0.7rem; color: var(--gray-400); text-align: right; }\n\n/* Navigation */\n.navRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.navBtn {\n  padding: 0.5rem 1rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  background: white;\n  font-size: 0.82rem;\n  color: var(--gray-700);\n  transition: all 0.12s;\n  min-width: 80px;\n}\n.navBtn:hover:not(:disabled) { background: var(--gray-50); }\n.navBtn:disabled { opacity: 0.35; cursor: not-allowed; }\n\n.navBtnPrimary {\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--red);\n  color: white;\n  font-size: 0.82rem;\n  font-weight: 500;\n  transition: background 0.12s;\n  min-width: 80px;\n}\n.navBtnPrimary:hover { background: var(--red-dark); }\n.navBtnPrimary:disabled { opacity: 0.35; cursor: not-allowed; }\n\n/* Submit Actions Row */\n.actionsRow {\n  display: flex;\n  justify-content: flex-start;\n  gap: 1rem;\n  padding: 1rem;\n  background: var(--gray-50);\n  border-top: 1px solid var(--border);\n  margin-top: 1rem;\n}\n\n.actionBtn {\n  padding: 0.65rem 1.25rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--green);\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n.actionBtn:hover:not(:disabled) {\n  background: #155a30;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(26, 92, 56, 0.2);\n}\n.actionBtn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.navCenter {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n  justify-content: center;\n  flex: 1;\n  max-height: 300px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.navDot {\n  width: 32px; height: 32px;\n  border-radius: 4px;\n  border: 1.5px solid var(--border);\n  background: white;\n  padding: 0;\n  transition: all 0.1s;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--gray-700);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.navDotScenario {\n  width: auto;\n  padding: 0 0.75rem;\n}\n\n.navDotActive { border-color: var(--red); background: var(--red); color: white; }\n.navDotAnswered { border-color: var(--green); background: var(--green-light); color: var(--green); font-weight: 700; }\n.navDotActive.navDotAnswered { background: var(--green); border-color: var(--green); color: white; }\n\n/* Submit */\n.submitArea {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem 1.25rem;\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.submitInfo { font-size: 0.78rem; color: var(--gray-500); }\n\n.submitBtn {\n  padding: 0.6rem 1.5rem;\n  background: var(--red);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: background 0.15s, opacity 0.15s;\n  white-space: nowrap;\n}\n.submitBtn:hover:not(:disabled) { background: var(--red-dark); }\n.submitBtn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Submitted */\n.submittedPage {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--gray-50);\n  padding: 1.5rem;\n}\n\n.submittedCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 2.5rem 2rem;\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  box-shadow: var(--shadow);\n}\n\n.submittedIcon {\n  width: 52px; height: 52px;\n  border-radius: 50%;\n  background: var(--green-light);\n  color: var(--green);\n  font-size: 1.4rem;\n  display: flex; align-items: center; justify-content: center;\n  margin: 0 auto 1.25rem;\n}\n\n.submittedTitle { font-size: 1.3rem; color: var(--black); margin-bottom: 0.65rem; }\n.submittedSub { font-size: 0.85rem; color: var(--gray-700); line-height: 1.6; margin-bottom: 0.85rem; }\n.submittedNote { font-size: 0.78rem; color: var(--gray-500); line-height: 1.6; margin-bottom: 1.5rem; }\n.countdownText { font-size: 0.85rem; color: var(--gray-600); margin-bottom: 1.5rem; font-weight: 500; }\n.countdownNumber { font-size: 1.1rem; font-weight: 700; color: var(--green); }\n.submittedBtn {\n  padding: 0.65rem 1.5rem;\n  background: var(--green);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n.submittedBtn:hover { background: #155a30; }\n\n/* Section Transition */\n.transitionPage {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--gray-50);\n  padding: 1.5rem;\n}\n\n.transitionCard {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 2.5rem 2rem;\n  max-width: 420px;\n  width: 100%;\n  text-align: center;\n  box-shadow: var(--shadow);\n  border-top: 3px solid var(--green-mid);\n}\n\n.transitionIcon {\n  width: 52px; height: 52px;\n  border-radius: 50%;\n  background: var(--green-light);\n  color: var(--green);\n  font-size: 1.4rem;\n  display: flex; align-items: center; justify-content: center;\n  margin: 0 auto 1.25rem;\n}\n\n.transitionTitle { font-size: 1rem; color: var(--gray-500); margin-bottom: 0.5rem; font-weight: 400; letter-spacing: 0.05em; }\n.transitionSectionName { font-size: 1.3rem; color: var(--black); margin-bottom: 1.25rem; font-weight: 600; }\n.transitionDesc { font-size: 0.85rem; color: var(--gray-700); line-height: 1.65; margin-bottom: 1.5rem; }\n.transitionMeta { background: var(--gray-50); padding: 1rem; border-radius: var(--radius); margin-bottom: 1.5rem; }\n.transitionCount { font-size: 0.85rem; color: var(--green); font-weight: 500; margin-bottom: 0.5rem; }\n.transitionCompleted { font-size: 0.8rem; color: var(--green); }\n\n.continueBtn {\n  padding: 0.65rem 2rem;\n  background: var(--green);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  transition: background 0.15s;\n  width: 100%;\n}\n.continueBtn:hover { background: var(--green-mid); }\n\n/* Submit Confirmation Modal */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.modalCard {\n  background: white;\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n  max-width: 380px;\n  width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  animation: modalSlideIn 0.2s ease;\n}\n\n.modalTitle {\n  font-size: 1.15rem;\n  color: var(--gray-900);\n  margin-bottom: 0.75rem;\n  font-weight: 600;\n}\n\n.modalMessage {\n  font-size: 0.85rem;\n  color: var(--gray-600);\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n}\n\n.modalActions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n.warningList {\n  background: var(--red-light);\n  border: 1px solid #fca5a5;\n  border-radius: var(--radius);\n  padding: 1rem;\n  margin: 1rem 0 1.5rem 0;\n}\n\n.warningItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.5rem 0;\n  font-size: 0.9rem;\n  color: var(--gray-800);\n}\n\n.warningItem:not(:last-child) {\n  border-bottom: 1px solid rgba(220, 38, 38, 0.2);\n}\n\n.warningItem strong {\n  color: var(--red);\n  font-weight: 600;\n}\n\n.modalBtnCancel {\n  padding: 0.55rem 1.25rem;\n  background: var(--gray-100);\n  color: var(--gray-700);\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: background 0.15s;\n}\n.modalBtnCancel:hover:not(:disabled) { background: var(--gray-200); }\n.modalBtnCancel:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.modalBtnSubmit {\n  padding: 0.55rem 1.25rem;\n  background: var(--red);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 500;\n  transition: background 0.15s;\n}\n.modalBtnSubmit:hover:not(:disabled) { background: var(--red-dark); }\n.modalBtnSubmit:disabled { opacity: 0.5; cursor: not-allowed; }\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes modalSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Skeleton Loaders */\n@keyframes shimmer {\n  0% { background-position: -1000px 0; }\n  100% { background-position: 1000px 0; }\n}\n\n.skeletonQuestionText {\n  height: 24px;\n  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: 6px;\n  margin-bottom: 1.5rem;\n}\n\n.skeletonOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.skeletonOption {\n  height: 56px;\n  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n}\n\n.skeletonLikert {\n  height: 120px;\n  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: var(--radius);\n}\n\n.skeletonTextarea {\n  height: 240px;\n  background: linear-gradient(90deg, var(--gray-100) 0%, var(--gray-150) 50%, var(--gray-100) 100%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n}\n\n/* Submission In Progress Overlay */\n.submissionOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  pointer-events: all;\n}\n\n.submissionSpinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n}\n\n.spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid rgba(255, 255, 255, 0.3);\n  border-top-color: white;\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.submissionSpinner p {\n  color: white;\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: 0.03em;\n}\n\n.loadingSpinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid var(--gray-200);\n  border-top-color: var(--green);\n  border-radius: 50%;\n  margin: 2rem auto 0;\n  animation: spin 1.2s linear infinite;\n}\n\n@media (max-width: 600px) {\n  .topBarTitle { display: none; }\n  .userLabel { display: none; }\n  .main { padding: 1rem 0.85rem; }\n  .questionCard { padding: 1.1rem; }\n  .likertBtn { width: 44px; height: 44px; font-size: 0.9rem; }\n  .navCenter { max-height: 44px; }\n  .navDot { width: 28px; height: 28px; font-size: 0.7rem; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AssessmentPage_page__zUjt6`,
	"topBar": `AssessmentPage_topBar__BCkIR`,
	"topBarLeft": `AssessmentPage_topBarLeft__mJcES`,
	"logoMark": `AssessmentPage_logoMark__gCyGC`,
	"topBarTitle": `AssessmentPage_topBarTitle__iSfL0`,
	"timeExpiredBanner": `AssessmentPage_timeExpiredBanner__iXFh9`,
	"timeExpiredContent": `AssessmentPage_timeExpiredContent__E4TI2`,
	"timeExpiredIcon": `AssessmentPage_timeExpiredIcon__MrT4K`,
	"timeExpiredText": `AssessmentPage_timeExpiredText__D2Y7C`,
	"topBarCenter": `AssessmentPage_topBarCenter__fqs9I`,
	"timer": `AssessmentPage_timer__H-Qrl`,
	"timerWarn": `AssessmentPage_timerWarn__uzDg2`,
	"timerIcon": `AssessmentPage_timerIcon__VuRcv`,
	"timerVal": `AssessmentPage_timerVal__pOb5q`,
	"timerExpired": `AssessmentPage_timerExpired__wGsB+`,
	"pulse": `AssessmentPage_pulse__vLf-B`,
	"topBarRight": `AssessmentPage_topBarRight__9W8Js`,
	"userLabel": `AssessmentPage_userLabel__k8b-u`,
	"progressOuter": `AssessmentPage_progressOuter__9VIpP`,
	"progressInner": `AssessmentPage_progressInner__yDRY+`,
	"cameraCard": `AssessmentPage_cameraCard__KTh9v`,
	"cameraLabel": `AssessmentPage_cameraLabel__8Xhzs`,
	"cameraVideo": `AssessmentPage_cameraVideo__9E0ca`,
	"tabs": `AssessmentPage_tabs__sDeyh`,
	"tabsContainer": `AssessmentPage_tabsContainer__yfAWv`,
	"tab": `AssessmentPage_tab__b3q4R`,
	"tabActive": `AssessmentPage_tabActive__3EXCE`,
	"tabDone": `AssessmentPage_tabDone__4R7Sc`,
	"tabCheck": `AssessmentPage_tabCheck__zg5h2`,
	"tabCount": `AssessmentPage_tabCount__AgZjn`,
	"tabSubmitBtn": `AssessmentPage_tabSubmitBtn__K6xeh`,
	"main": `AssessmentPage_main__irc5G`,
	"mainBlurred": `AssessmentPage_mainBlurred__eU5rA`,
	"sectionHeader": `AssessmentPage_sectionHeader__L-SkZ`,
	"sectionBadge": `AssessmentPage_sectionBadge__hN4p9`,
	"qCount": `AssessmentPage_qCount__brk5e`,
	"loading": `AssessmentPage_loading__Gv-Up`,
	"scenarioCardHeader": `AssessmentPage_scenarioCardHeader__XbeKY`,
	"scenarioBadge": `AssessmentPage_scenarioBadge__nnXgo`,
	"scenarioTitle": `AssessmentPage_scenarioTitle__UcK3h`,
	"scenarioCardContent": `AssessmentPage_scenarioCardContent__HWzms`,
	"scenarioCardFooter": `AssessmentPage_scenarioCardFooter__zaVpy`,
	"accessBlockedPage": `AssessmentPage_accessBlockedPage__e44N1`,
	"accessBlockedCard": `AssessmentPage_accessBlockedCard__kJ+sM`,
	"accessBlockedIcon": `AssessmentPage_accessBlockedIcon__lEoVf`,
	"accessBlockedTitle": `AssessmentPage_accessBlockedTitle__uNbL6`,
	"accessBlockedMessage": `AssessmentPage_accessBlockedMessage__LXgCF`,
	"accessBlockedWait": `AssessmentPage_accessBlockedWait__5cD8m`,
	"scenarioCardWrapper": `AssessmentPage_scenarioCardWrapper__Wfrh1`,
	"fadeIn": `AssessmentPage_fadeIn__Ncd9i`,
	"scenarioHeader": `AssessmentPage_scenarioHeader__Lk0YN`,
	"scenarioHeaderTitle": `AssessmentPage_scenarioHeaderTitle__pPPX5`,
	"scenarioHeaderSubtitle": `AssessmentPage_scenarioHeaderSubtitle__qhuLt`,
	"scenarioBody": `AssessmentPage_scenarioBody__NvMFS`,
	"kpiTable": `AssessmentPage_kpiTable__8IAbk`,
	"percentOrange": `AssessmentPage_percentOrange__F90M7`,
	"percentRed": `AssessmentPage_percentRed__AFiN3`,
	"percentGreen": `AssessmentPage_percentGreen__xunrj`,
	"contextualNotes": `AssessmentPage_contextualNotes__bgrO0`,
	"contextualNotesTitle": `AssessmentPage_contextualNotesTitle__f05eg`,
	"contextualNotesList": `AssessmentPage_contextualNotesList__cbM9I`,
	"questionCard": `AssessmentPage_questionCard__74PTR`,
	"questionText": `AssessmentPage_questionText__TXxdV`,
	"qNum": `AssessmentPage_qNum__wWSWS`,
	"options": `AssessmentPage_options__lidJo`,
	"option": `AssessmentPage_option__pXNFw`,
	"optionSelected": `AssessmentPage_optionSelected__xwTg8`,
	"optionLabel": `AssessmentPage_optionLabel__meQkF`,
	"optionText": `AssessmentPage_optionText__khvuG`,
	"likertWrap": `AssessmentPage_likertWrap__KEBYb`,
	"likertScale": `AssessmentPage_likertScale__oxcyQ`,
	"likertOption": `AssessmentPage_likertOption__JssWm`,
	"likertLabel": `AssessmentPage_likertLabel__45pZ1`,
	"likertBtn": `AssessmentPage_likertBtn__3Ecz-`,
	"likertSelected": `AssessmentPage_likertSelected__V1fH4`,
	"likertMsg": `AssessmentPage_likertMsg__oeKeR`,
	"optionMsg": `AssessmentPage_optionMsg__17dNq`,
	"openMsg": `AssessmentPage_openMsg__wtEPT`,
	"openWrap": `AssessmentPage_openWrap__dNEgq`,
	"textarea": `AssessmentPage_textarea__4UB-r`,
	"charCount": `AssessmentPage_charCount__NzaxM`,
	"navRow": `AssessmentPage_navRow__IQHcM`,
	"navBtn": `AssessmentPage_navBtn__giaIj`,
	"navBtnPrimary": `AssessmentPage_navBtnPrimary__a0EI7`,
	"actionsRow": `AssessmentPage_actionsRow__8CarW`,
	"actionBtn": `AssessmentPage_actionBtn__DrWzI`,
	"navCenter": `AssessmentPage_navCenter__bfpL9`,
	"navDot": `AssessmentPage_navDot__OfHxM`,
	"navDotScenario": `AssessmentPage_navDotScenario__WxaoO`,
	"navDotActive": `AssessmentPage_navDotActive__JsJDz`,
	"navDotAnswered": `AssessmentPage_navDotAnswered__mgoko`,
	"submitArea": `AssessmentPage_submitArea__wUdE6`,
	"submitInfo": `AssessmentPage_submitInfo__5kWaW`,
	"submitBtn": `AssessmentPage_submitBtn__Rz2o4`,
	"submittedPage": `AssessmentPage_submittedPage__OkOhO`,
	"submittedCard": `AssessmentPage_submittedCard__mKhur`,
	"submittedIcon": `AssessmentPage_submittedIcon__G3MLS`,
	"submittedTitle": `AssessmentPage_submittedTitle__p2x2h`,
	"submittedSub": `AssessmentPage_submittedSub__bK3Ix`,
	"submittedNote": `AssessmentPage_submittedNote__qg3+b`,
	"countdownText": `AssessmentPage_countdownText__dwwf9`,
	"countdownNumber": `AssessmentPage_countdownNumber__Hr2+i`,
	"submittedBtn": `AssessmentPage_submittedBtn__v06gT`,
	"transitionPage": `AssessmentPage_transitionPage__t+y2Q`,
	"transitionCard": `AssessmentPage_transitionCard__jSRv3`,
	"transitionIcon": `AssessmentPage_transitionIcon__qKbxd`,
	"transitionTitle": `AssessmentPage_transitionTitle__22JBM`,
	"transitionSectionName": `AssessmentPage_transitionSectionName__Suudi`,
	"transitionDesc": `AssessmentPage_transitionDesc__HE+FN`,
	"transitionMeta": `AssessmentPage_transitionMeta__28-6B`,
	"transitionCount": `AssessmentPage_transitionCount__gDZi1`,
	"transitionCompleted": `AssessmentPage_transitionCompleted__CchLL`,
	"continueBtn": `AssessmentPage_continueBtn__bjHdC`,
	"modalOverlay": `AssessmentPage_modalOverlay__AFguV`,
	"modalCard": `AssessmentPage_modalCard__5grVz`,
	"modalSlideIn": `AssessmentPage_modalSlideIn__elJmG`,
	"modalTitle": `AssessmentPage_modalTitle__X8cl6`,
	"modalMessage": `AssessmentPage_modalMessage__2wrHE`,
	"modalActions": `AssessmentPage_modalActions__HQKTr`,
	"warningList": `AssessmentPage_warningList__dyLb+`,
	"warningItem": `AssessmentPage_warningItem__JhRGG`,
	"modalBtnCancel": `AssessmentPage_modalBtnCancel__HrbUe`,
	"modalBtnSubmit": `AssessmentPage_modalBtnSubmit__x7Led`,
	"skeletonQuestionText": `AssessmentPage_skeletonQuestionText__vumFn`,
	"shimmer": `AssessmentPage_shimmer__Rvpmw`,
	"skeletonOptions": `AssessmentPage_skeletonOptions__xuf5O`,
	"skeletonOption": `AssessmentPage_skeletonOption__sktIo`,
	"skeletonLikert": `AssessmentPage_skeletonLikert__4sT3U`,
	"skeletonTextarea": `AssessmentPage_skeletonTextarea__1djA5`,
	"submissionOverlay": `AssessmentPage_submissionOverlay__lZxNf`,
	"submissionSpinner": `AssessmentPage_submissionSpinner__UVsVU`,
	"spinner": `AssessmentPage_spinner__cqGTA`,
	"spin": `AssessmentPage_spin__c+LPT`,
	"loadingSpinner": `AssessmentPage_loadingSpinner__KZoKU`
};
export default ___CSS_LOADER_EXPORT___;
